export default __webpack_public_path__ + "static/media/5-7t.eb579706.png";